export const visit = (vm, at) => {
at({ "fr": { "uiAddonTeams": { "teamSelectLabelOne": "1\xA0\xE9quipe s\xE9lectionn\xE9e", "teamSelectLabelMany": "{{ count }}\xA0\xE9quipes s\xE9lectionn\xE9es", "selectTeams": "S\xE9lectionner des \xE9quipes", "selectAll": "Tout s\xE9lectionner ({{ teamName }})" } } });
};